import {
  AcceptLegalTextsMailRequest,
  GetLegalTextsByIdentifierRequest,
  SharedLegalApi
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useSharedLegalApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new SharedLegalApi(configuration),
    [configuration]
  );

  const getLegalTextsByIdentifier = useCallback(
    (requestParameters: GetLegalTextsByIdentifierRequest) =>
      apiInstance
        .getLegalTextsByIdentifier(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  const acceptLegalTexts = useCallback(
    (requestParameters: AcceptLegalTextsMailRequest) =>
      apiInstance.acceptLegalTextsMail(requestParameters).catch(handleError),
    [apiInstance]
  );

  return {
    getLegalTextsByIdentifier,
    acceptLegalTexts
  };
};
